import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { loginSuccess } from '../../store/slices/authSlice';
import { useNavigate, Link } from 'react-router-dom';
import { Form, Input, Button, message, Card, Typography } from 'antd';
import {
  UserOutlined,
  LockOutlined,
  ArrowLeftOutlined,
} from '@ant-design/icons';
import axios from 'axios';
import API_BASE_URL from '../../config/api';
import { useSiteSettings } from '../../context/SiteSettingsContext';
import SystemIcon from '../../components/SystemIcon';
import './LoginPage.css';

const { Title, Text } = Typography;

const Login = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { settings } = useSiteSettings();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const user = localStorage.getItem('user');
    // หากพบ token แล้ว path คือ '/' ให้ redirect ไป dashboard
    if (user && window.location.pathname === '/login') {
      navigate('/dashboard');
    }
  }, [navigate]);

  const onFinish = async (values) => {
    setLoading(true);
    try {
      const res = await axios.post(`${API_BASE_URL}/api/auth/login`, values);
      const { token } = res.data;
      dispatch(loginSuccess({ token, user: res.data }));
      localStorage.setItem('token', token);
      localStorage.setItem('user', JSON.stringify(res.data));

      message.success('เข้าสู่ระบบสำเร็จ');
      navigate('/dashboard');
    } catch (error) {
      message.error('ชื่อผู้ใช้หรือรหัสผ่านไม่ถูกต้อง');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <Card className="login-card">
        <div className="login-brand">
          <span className="login-brand-icon">
            <SystemIcon icon={settings.system_icon} size={32} />
          </span>
        </div>
        <Title level={3} className="login-title">
          เข้าสู่ระบบ
        </Title>
        <Text className="login-subtitle">
          ระบบสารสนเทศคณะสงฆ์ ภาค ๔-๕ (ธรรมยุต)
        </Text>

        <Form layout="vertical" onFinish={onFinish} className="login-form">
          <Form.Item
            name="username"
            label="ชื่อผู้ใช้"
            rules={[{ required: true, message: 'กรุณากรอกชื่อผู้ใช้' }]}
          >
            <Input size="large" prefix={<UserOutlined />} placeholder="ชื่อผู้ใช้" />
          </Form.Item>

          <Form.Item
            name="password"
            label="รหัสผ่าน"
            rules={[{ required: true, message: 'กรุณากรอกรหัสผ่าน' }]}
          >
            <Input.Password size="large" prefix={<LockOutlined />} placeholder="รหัสผ่าน" />
          </Form.Item>

          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              loading={loading}
              size="large"
              block
              className="login-btn"
            >
              เข้าสู่ระบบ
            </Button>
          </Form.Item>
        </Form>

        <div className="login-back-zone">
          <Link to="/" className="login-back">
            <ArrowLeftOutlined /> กลับหน้าหลัก
          </Link>
        </div>
      </Card>
    </div>
  );
};

export default Login;

